// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createBtn {
    background-color: var(--primary-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--white-color) !important;
    padding: 0.8rem 1rem 0.8rem 1rem !important;
    border: none !important;
    cursor: pointer !important;
}

.h1 {
    font-size: 20px !important;
    color: var(--black-color) !important;
    font-weight: 900 !important;
}

.heading {
    font-size: 18px !important;
    color: var(--black-color) !important;
    font-weight: 900 !important;
}

.labelDescription {
    font-size: 12px !important;
    color:  var(--gray-color) !important;
    font-weight: 900 !important;
}


.btnContent {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    color: var(--white-color) !important;
}

.contentLeft {
    font-size: 16px !important;
    color: var(--black-color) !important;
    font-weight: 900 !important;
}

.contentRight {
    font-size: 16px !important;
    color: var(--black-color) !important;
    font-weight: 500 !important;
}

.resetbtn {
    background-color: var(--white-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--primary-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: 1px solid var(--primary-color) !important;
    cursor: pointer !important;
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/licenseManagement/subscriptionPlans/subscriptionPlans.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;AAC/B;;;AAGA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;IAC3C,iDAAiD;IACjD,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".createBtn {\n    background-color: var(--primary-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--white-color) !important;\n    padding: 0.8rem 1rem 0.8rem 1rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.h1 {\n    font-size: 20px !important;\n    color: var(--black-color) !important;\n    font-weight: 900 !important;\n}\n\n.heading {\n    font-size: 18px !important;\n    color: var(--black-color) !important;\n    font-weight: 900 !important;\n}\n\n.labelDescription {\n    font-size: 12px !important;\n    color:  var(--gray-color) !important;\n    font-weight: 900 !important;\n}\n\n\n.btnContent {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    color: var(--white-color) !important;\n}\n\n.contentLeft {\n    font-size: 16px !important;\n    color: var(--black-color) !important;\n    font-weight: 900 !important;\n}\n\n.contentRight {\n    font-size: 16px !important;\n    color: var(--black-color) !important;\n    font-weight: 500 !important;\n}\n\n.resetbtn {\n    background-color: var(--white-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--primary-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: 1px solid var(--primary-color) !important;\n    cursor: pointer !important;\n    box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
